module.exports = __webpack_public_path__ + "static/media/cooler-2-fr.1cdf41bf.png";